import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";

import VisibilitySensor from "react-visibility-sensor";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import { Navigation } from "swiper/modules";

import img1 from "../../../assets/img/home/services/img1.webp";
import img2 from "../../../assets/img/home/services/img2.webp";

import arrowRight from "../../../assets/img/components/arrow-right.webp";
import arrowLeft from "../../../assets/img/components/arrow-left.webp";

const serviceData = [
  { id: 1, class: "card-bg blue", titleKey: "services_road", contentKey: "services_road_text1", imageUrl: img2 },
  { id: 2, class: "card-bg orange", titleKey: "services_storage", contentKey: "services_storage_text", imageUrl: img1 },
  { id: 3, class: "card-bg blue", titleKey: "services_road", contentKey: "services_road_text1", imageUrl: img2 },
  { id: 4, class: "card-bg orange", titleKey: "services_storage", contentKey: "services_storage_text", imageUrl: img1 },
  { id: 5, class: "card-bg blue", titleKey: "services_road", contentKey: "services_road_text1", imageUrl: img2 },
  { id: 6, class: "card-bg orange", titleKey: "services_storage", contentKey: "services_storage_text", imageUrl: img1 },
];

const breakpoints = {
  1200: {
    slidesPerView: 2,
  },
  900: {
    slidesPerView: 1,
  },
  700: {
    slidesPerView: 2,
  },
  0: {
    slidesPerView: 1,
    effect: "none",
  },
};

function HomeServices() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <section>
        <div className={`homeServices ${isVisible ? "visible" : ""}`}>
          <div className="homeServicesText">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("services_title")} <span>{t("services_title_span")}</span>
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("services_text")}
            </p>
            <a href="/services" reloadDocument>
              <button>{t("services_see_more")}</button>
            </a>
          </div>
          <Swiper
            className={`${isVisible ? "visible" : ""}`}
            spaceBetween={0}
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            speed={800}
            keyboard={true}
            loop={true}
            breakpoints={breakpoints}
            slidesPerView={2}
          >
            <div className="swiper-button-next">
              <img src={arrowRight} width={"35px"} height={"35px"} alt="" />
            </div>
            {serviceData.map((item) => (
              <SwiperSlide key={item.id}>
                <div className={item.class}>
                  <div className="card">
                    <img
                      src={item.imageUrl}
                      alt=""
                      width={"150px"}
                      height={"150px"}
                    />
                    <h3>{t(item.titleKey)}</h3>
                    <p>{t(item.contentKey)}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="swiper-button-prev">
              <img src={arrowLeft} width={"35px"} height={"35px"} alt="" />
            </div>
          </Swiper>
        </div>
      </section>
    </VisibilitySensor>
  );
}

export default HomeServices;
